[
  {
    "code": "SB-CT",
    "name": "Capital Territory (Honiara)"
  },
  {
    "code": "SB-CE",
    "name": "Central"
  },
  {
    "code": "SB-CH",
    "name": "Choiseul"
  },
  {
    "code": "SB-GU",
    "name": "Guadalcanal"
  },
  {
    "code": "SB-IS",
    "name": "Isabel"
  },
  {
    "code": "SB-MK",
    "name": "Makira-Ulawa"
  },
  {
    "code": "SB-ML",
    "name": "Malaita"
  },
  {
    "code": "SB-RB",
    "name": "Rennell and Bellona"
  },
  {
    "code": "SB-TE",
    "name": "Temotu"
  },
  {
    "code": "SB-WE",
    "name": "Western"
  }
]